/**
 * Formats a room code with dash for display.
 */
export function formatRoomCode(code: string): string {
  const upper = code.toUpperCase();
  if (upper.length === 6) {
    return `${upper.slice(0, 3)}-${upper.slice(3)}`;
  }
  return upper;
}

/**
 * Strips formatting from room code.
 */
export function stripRoomCode(code: string): string {
  return code.replace(/[^A-Z0-9]/gi, '').toUpperCase();
}

/**
 * Formats duration in seconds to mm:ss.
 */
export function formatDuration(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

/**
 * Formats participant count.
 */
export function formatParticipantCount(count: number, max: number): string {
  return `${count}/${max} participants`;
}

/**
 * Truncates text with ellipsis.
 */
export function truncate(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 3)}...`;
}

/**
 * Gets initials from display name.
 */
export function getInitials(name: string): string {
  const words = name.trim().split(/\s+/);

  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase();
  }

  return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
}
